import React, { useEffect, useState } from "react";

import axios from "axios";

import { TextField } from "@material-ui/core";
import {
  Autocomplete,
  GoogleMap,
  LoadScript,
  Marker,
} from "@react-google-maps/api";
import RegularButton from "components/CustomButtons/Button";

import { validateObject } from "helpers/validateObject";
import { useToggle } from "hooks/useToggle";
import MyLocationIcon from "@material-ui/icons/MyLocation";
import StreetviewIcon from "@material-ui/icons/Streetview";

import { CoordsComponent } from "./CoordsComponent";
import { Search } from "@material-ui/icons";
import { useForm } from "hooks/useForm";
import { useSearch } from "hooks/useSearch";
import { ButtonsWrapper, NoLocationText } from "./styled";

const libraries = ["places"];
const mapApiKey = process.env.REACT_APP_MAPS_API_KEY;

const initialValues = {
  coordLat: "",
  coordLng: "",
};

const fieldValidations = {
  coordLat: { required: true },
  coordLng: { required: true },
};
export const MapComponent = ({
  onPlaceChanged = () => {},
  onSetLocation = () => {},
  location = null,
  editedLocation = null,
  blockSearch = false,
  switchCss = false,
}) => {
  const [autoComplete, setAutoComplete] = useState(null);
  const [mapPosition, setMapPosition] = useState({
    lat: location?.latitude || 0,
    lng: location?.longitude || 0,
  });
  const [isByCoords, setIsByCoords] = useToggle();
  const [newZoom, setNewZoom] = useState(8);
  const [pointer, setPointer] = useState({
    url: null,
  });

  const {
    inputValues,
    handleInputOnChange,
    runValidates,
    fieldErrors,
  } = useForm(initialValues, fieldValidations);

  const { coordLat, coordLng } = inputValues;
  const { setSnackbar } = useSearch();

  const getMapByCoordinates = async (lat, lng) => {
    const urlMap = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${mapApiKey}`;

    try {
      const resp = await axios.get(urlMap);

      const { address_components } = resp.data.results[0];

      onPlaceChanged(address_components);
    } catch (error) {
      console.error(error);
    }
  };

  const handleAutoCompleteIsLoad = (inputAutoComplete) => {
    setAutoComplete(inputAutoComplete);
  };

  const handleAutoCompletePlaceIsChanged = () => {
    if (autoComplete !== null) {
      setAutoComplete(autoComplete);
      const places = autoComplete.getPlace();
      onPlaceChanged(places.address_components);
      const lat = places?.geometry?.location.lat();
      const lon = places?.geometry?.location.lng();
      onSetLocation && onSetLocation({ latitude: lat, longitude: lon });
    }
  };

  const handleDragEnd = (value) => {
    const latLng = value.latLng;
    const lat = latLng.lat();
    const lng = latLng.lng();

    if (onSetLocation) {
      onSetLocation({ latitude: lat, longitude: lng });
    }
    handleCoords(lat, lng);
    setMapPosition({ lat, lng });
  };

  const handleCoords = (lat, lng) => {
    // if(runValidates()) return
    if (lat.length === 0 || lng.length === 0)
      return setSnackbar("Coordenadas Requeridas");

    getMapByCoordinates(lat, lng);
  };

  useEffect(() => {
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(function(position) {
        const lat = position.coords.latitude;
        const lon = position.coords.longitude;

        if (validateObject(editedLocation) && editedLocation?.address) {
          const { address } = editedLocation;
          onSetLocation &&
            onSetLocation({
              latitude: address.latitude,
              longitude: address.longitude,
            });
        } else {
          onSetLocation && onSetLocation({ latitude: lat, longitude: lon });
        }
      });
    } else {
      console.log("Error on location");
    }
  }, []);

  useEffect(() => {
    setNewZoom(18);
  }, []);

  useEffect(() => {
    setMapPosition({
      lat: location?.latitude || 0,
      lng: location?.longitude || 0,
    });
  }, [location]);

  return (
    <LoadScript
      libraries={libraries}
      googleMapsApiKey={process.env.REACT_APP_MAPS_API_KEY || ""}
    >
      {blockSearch ? null : isByCoords ? (
        <CoordsComponent
          lat={coordLat}
          lng={coordLng}
          onChange={handleInputOnChange}
          errors={fieldErrors}
        />
      ) : (
        <Autocomplete
          onLoad={handleAutoCompleteIsLoad}
          restrictions={{
            country: ["mx"],
          }}
          onPlaceChanged={handleAutoCompletePlaceIsChanged}
          style={{ position: "absolute", left: 0, bottom: 0 }}
        >
          <>
            <TextField
              fullWidth
              label="Dirección Autocompletado"
              variant="outlined"
              placeholder=""
              style={{
                marginBottom: 8,
              }}
            />
          </>
        </Autocomplete>
      )}
      {!blockSearch && (
        <ButtonsWrapper>
          {isByCoords && (
            <RegularButton
              justIcon
              color="info"
              onClick={() => handleCoords(coordLat, coordLng)}
              tooltip="Buscar"
              style={{ margin: 0 }}
            >
              <Search />
            </RegularButton>
          )}
          <RegularButton
            justIcon
            color="success"
            onClick={setIsByCoords}
            tooltip={
              isByCoords
                ? "Ubicación por Dirección"
                : "Ubicación por coordenadas"
            }
            style={{ margin: 0 }}
          >
            {!isByCoords ? <MyLocationIcon /> : <StreetviewIcon />}
          </RegularButton>
        </ButtonsWrapper>
      )}
      <GoogleMap
        mapContainerClassName={
          switchCss ? "form_customer_map_" : "form_customer_map"
        }
        zoom={newZoom}
        center={mapPosition}
        options={{
          fullscreenControl: false,
        }}
      >
        <Marker
          draggable={true}
          onDragEnd={handleDragEnd}
          position={{
            lat: location?.latitude,
            lng: location?.longitude,
          }}
          icon={pointer}
        />
        {!location ? (
          <NoLocationText variant="subtitle2">
            Ubicación no disponible
          </NoLocationText>
        ) : null}
      </GoogleMap>
    </LoadScript>
  );
};
